/* ═══════════════════════════════════════════════════════════════════════════
 * VMFS Nectar Builder — Inline tabbed configurator
 * ─────────────────────────────────────────────────────────────────────────
 * • Tabs render directly in the right column (sticky on scroll)
 * • Each option group has a `?` button → inline expandable help drawer
 * • Full ARIA: tablist + tab + tabpanel, arrow/Home/End keyboard nav
 * • All preserved: gallery, image override, spec stack, pricing tiers,
 *   lead time, Cloudflare Worker submission
 * ═══════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  /* ── Helpers ──────────────────────────────────────────────────────────── */
  function unesc(s){
    if(s==null) return '';
    var t=document.createElement('textarea'); t.innerHTML=String(s);
    return t.value;
  }
  function money(cents, sym){
    sym = sym || '$';
    var sign = cents < 0 ? '-' : '';
    var n = Math.abs(Number(cents||0)) / 100;
    return sign + sym + n.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
  }
  function escAttr(s){
    return String(s==null?'':s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function escHtml(s){
    return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function readConfig(root){
    try{ return JSON.parse(unesc(root.querySelector('[data-config]').textContent||'')); }
    catch(e){ console.error('[VMFS] Bad config_json:', e); return null; }
  }
  function readImageRules(){
    var node = document.querySelector('[data-vmfs-image-rules]');
    if(!node) return [];
    try{ return JSON.parse(unesc(node.textContent||'[]')); }
    catch(e){ return []; }
  }
  function meetsRules(state, rules){
    if(!rules) return true;
    var when = rules.when || rules.if;
    if(!when) return true;
    return Object.keys(when).every(function(k){
      var need = when[k]; var got = state[k];
      if(Array.isArray(need)) return need.indexOf(got) >= 0;
      if(Array.isArray(got))  return got.indexOf(need) >= 0;
      return got === need;
    });
  }

  /* ── Spec icons ───────────────────────────────────────────────────────── */
  var SPEC_ICONS = {
    slots:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>',
    capacity:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
    temperature: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/></svg>',
    delivery:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
    tray:        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>',
    display:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',
    dimensions:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 14 4 20 10 20"/><polyline points="20 10 20 4 14 4"/><line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/></svg>',
    weight:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 6.5h11l1.4 14a2 2 0 0 1-2 2.5h-9.8a2 2 0 0 1-2-2.5z"/><path d="M9.5 6.5a2.5 2.5 0 0 1 5 0"/><line x1="12" y1="11" x2="12" y2="17"/></svg>',
    height:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="3" x2="12" y2="21"/><polyline points="6 9 12 3 18 9"/><polyline points="6 15 12 21 18 15"/></svg>',
    width:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><polyline points="9 6 3 12 9 18"/><polyline points="15 6 21 12 15 18"/></svg>',
    power:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    payment:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>',
    wifi:        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.55a11 11 0 0 1 14 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg>',
    'default':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
  };
  function getSpecIcon(name){ return SPEC_ICONS[(name||'').toLowerCase()] || SPEC_ICONS['default']; }

  /* ── Default categories (fallback if config omits them) ───────────────── */
  var DEFAULT_CATEGORIES = [
    {id:'build',    label:'Build'},
    {id:'payments', label:'Payments'},
    {id:'branding', label:'Branding'},
    {id:'shipping', label:'Shipping'},
    {id:'warranty', label:'Warranty'}
  ];

  /* ── Hint formatter ───────────────────────────────────────────────────── */
  function formatHint(text){
    if(!text) return '<p class="vmfs-tt-para">No additional information available.</p>';
    var lines = String(text).split('\n');
    var html = '';
    var inList = false;
    function closeList(){ if(inList){ html += '</ul>'; inList = false; } }
    for(var i=0; i<lines.length; i++){
      var raw = lines[i];
      var trimmed = raw.trim();
      if(trimmed === ''){ closeList(); continue; }
      if(/^[A-Z0-9 \-&'/]+$/.test(trimmed) && trimmed.length >= 10 && trimmed === trimmed.toUpperCase()){
        closeList();
        html += '<span class="vmfs-tt-heading">' + escHtml(trimmed) + '</span>';
        continue;
      }
      if(/^•\s+/.test(trimmed)){
        if(!inList){ html += '<ul class="vmfs-tt-list">'; inList = true; }
        var item = trimmed.replace(/^•\s+/, '');
        var dashIdx = item.indexOf(' — ');
        if(dashIdx > 0){
          var name = item.slice(0, dashIdx);
          var rest = item.slice(dashIdx + 3);
          html += '<li><span class="vmfs-tt-name">' + escHtml(name) + '</span> — ' + escHtml(rest) + '</li>';
        } else {
          html += '<li>' + escHtml(item) + '</li>';
        }
        continue;
      }
      closeList();
      html += '<span class="vmfs-tt-para">' + escHtml(trimmed) + '</span>';
    }
    closeList();
    return html;
  }

  /* ── Smart label splitter: extracts parenthetical text into description ── */
  function splitLabel(label, existingDesc){
    var raw = String(label || '');
    // Always strip "(Default)" / "(Optional)" markers
    var cleaned = raw.replace(/\s*\((?:Default|Optional)\)\s*/ig, '').trim();
    if(existingDesc){
      return { label: cleaned, desc: String(existingDesc) };
    }
    // Try to extract trailing parenthetical
    var m = cleaned.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if(m){
      var inner = m[2].trim();
      return { label: m[1].trim(), desc: inner };
    }
    return { label: cleaned, desc: '' };
  }

  /* ═══════════════════════════════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════════════════════════════ */
  function init(root){
    var config = readConfig(root);
    if(!config || !Array.isArray(config.groups)){
      console.error('[VMFS] Missing or invalid config'); return;
    }

    var sym       = config.currencySymbol || '$';
    var WORKER_URL= config.workerUrl || '';
    var baseCents = Number(config.basePriceCents || 0);
    var leadTimes = config.leadTimes || {};
    var imageRules= readImageRules();
    var state     = {};
    var openHelpId = null;  // currently expanded help group id

    var categories = (Array.isArray(config.categories) && config.categories.length)
      ? config.categories.slice()
      : DEFAULT_CATEGORIES.slice();
    var firstCatId = categories[0] ? categories[0].id : 'build';
    var currentTab = firstCatId;

    var els = {
      cfgTabs:        root.querySelector('[data-cfg-tabs]'),
      cfgBody:        root.querySelector('[data-cfg-body]'),
      basePriceEl:    root.querySelector('[data-base-price]'),
      optsPriceEl:    root.querySelector('[data-options-price]'),
      totalEl:        root.querySelector('[data-total-price]'),
      leadDot:        root.querySelector('[data-lead-dot]'),
      leadLabel:      root.querySelector('[data-lead-label]'),
      leadDays:       root.querySelector('[data-lead-days]'),
      leadCheckbox:   root.querySelector('[data-lead-checkbox]'),
      orderBtn:       root.querySelector('[data-order-btn]'),
      summaryToggle:  root.querySelector('[data-summary-toggle]'),
      summaryChevron: root.querySelector('[data-summary-chevron]'),
      summaryPanel:   root.querySelector('[data-summary-panel]'),
      summaryBody:    root.querySelector('[data-summary-body]'),
      toggleLabel:    root.querySelector('[data-toggle-label]'),
      form:           root.querySelector('[data-vmfs-form]'),
      props:          root.querySelector('[data-props]'),
      descTabs:       root.querySelectorAll('[data-tab]'),
      descPanels:     root.querySelectorAll('[data-panel]'),
      galleryTrack:   root.querySelector('[data-gallery-track]'),
      galleryMain:    root.querySelector('[data-main-img]'),
      galleryOverride:root.querySelector('[data-gallery-override]'),
      overrideImg:    root.querySelector('[data-override-img]'),
      galleryPrev:    root.querySelector('[data-gallery-prev]'),
      galleryNext:    root.querySelector('[data-gallery-next]'),
      counterCurrent: root.querySelector('[data-counter-current]'),
      counterTotal:   root.querySelector('[data-counter-total]'),
      thumbs:         root.querySelectorAll('[data-thumb-index]'),
      specStack:      root.querySelector('[data-spec-stack]')
    };

    /* ═════════════════════════════════════════════════════════════════════
       TABS
       ═══════════════════════════════════════════════════════════════════ */
    function renderTabs(){
      if(!els.cfgTabs) return;
      var html = '';
      categories.forEach(function(cat){
        var active = cat.id === currentTab;
        var groupCount = config.groups.filter(function(g){
          return (g.category || firstCatId) === cat.id && meetsRules(state, g.rules);
        }).length;
        html += '<button type="button" '
              + 'role="tab" '
              + 'id="vmfs-tab-' + cat.id + '" '
              + 'aria-controls="vmfs-panel-' + cat.id + '" '
              + 'aria-selected="' + active + '" '
              + 'tabindex="' + (active ? '0' : '-1') + '" '
              + 'data-tab-id="' + cat.id + '" '
              + 'class="vmfs-ctab' + (active ? ' is-active' : '') + '">'
              + '<span class="vmfs-ctab__label">' + escHtml(cat.label) + '</span>'
              + (groupCount > 0 ? '<span class="vmfs-ctab__count">' + groupCount + '</span>' : '')
              + '</button>';
      });
      els.cfgTabs.innerHTML = html;
      Array.prototype.forEach.call(els.cfgTabs.querySelectorAll('[role="tab"]'), function(tab){
        tab.addEventListener('click', function(){ switchTab(tab.dataset.tabId); });
        tab.addEventListener('keydown', handleTabKeydown);
      });
    }
    function handleTabKeydown(e){
      var tabs = Array.prototype.slice.call(els.cfgTabs.querySelectorAll('[role="tab"]'));
      var idx = tabs.indexOf(e.currentTarget);
      var nextIdx = -1;
      switch(e.key){
        case 'ArrowRight': nextIdx = (idx + 1) % tabs.length; break;
        case 'ArrowLeft':  nextIdx = (idx - 1 + tabs.length) % tabs.length; break;
        case 'Home':       nextIdx = 0; break;
        case 'End':        nextIdx = tabs.length - 1; break;
      }
      if(nextIdx >= 0){
        e.preventDefault();
        var t = tabs[nextIdx];
        switchTab(t.dataset.tabId);
        t.focus();
      }
    }
    function switchTab(tabId){
      currentTab = tabId;
      openHelpId = null; // close any open help when switching tabs
      renderTabs();
      renderBody();
    }

    /* ═════════════════════════════════════════════════════════════════════
       BODY
       ═══════════════════════════════════════════════════════════════════ */
    function renderBody(){
      if(!els.cfgBody) return;
      var html = '';
      categories.forEach(function(cat){
        var active = cat.id === currentTab;
        var groupsInCat = config.groups.filter(function(g){
          return (g.category || firstCatId) === cat.id && meetsRules(state, g.rules);
        });
        html += '<div role="tabpanel" '
              + 'id="vmfs-panel-' + cat.id + '" '
              + 'aria-labelledby="vmfs-tab-' + cat.id + '" '
              + 'class="vmfs-cpanel"'
              + (active ? '' : ' hidden') + '>';
        if(groupsInCat.length){
          groupsInCat.forEach(function(g){ html += renderGroupHtml(g); });
        } else {
          html += '<p class="vmfs-cpanel-empty">No options here for the current configuration.</p>';
        }
        html += '</div>';
      });
      els.cfgBody.innerHTML = html;
      bindBodyEvents();
    }

    function renderGroupHtml(g){
      var label = escHtml(g.label || '');
      var hasHint = !!(g.hint && String(g.hint).trim());
      var helpOpen = openHelpId === g.id;

      var html = '<div class="vmfs-mopt" data-group-render="' + escAttr(g.id) + '">'
               + '<div class="vmfs-mopt__head">'
               + '<h3 class="vmfs-mopt__label" id="vmfs-mopt-label-' + escAttr(g.id) + '">' + label + '</h3>';
      if(hasHint){
        html += '<button type="button" '
              + 'class="vmfs-mopt__help" '
              + 'data-help-toggle="' + escAttr(g.id) + '" '
              + 'aria-expanded="' + helpOpen + '" '
              + 'aria-controls="vmfs-help-' + escAttr(g.id) + '" '
              + 'aria-label="' + (helpOpen ? 'Hide' : 'Show') + ' help for ' + escAttr(g.label || 'this option') + '">'
              + '?'
              + '</button>';
      }
      html += '</div>';

      if(hasHint){
        html += '<div id="vmfs-help-' + escAttr(g.id) + '" class="vmfs-help-inline"' + (helpOpen ? '' : ' hidden') + '>'
              + formatHint(g.hint)
              + '</div>';
      }

      var display = g.display || 'switch';
      if(display === 'radio')        html += renderRadioCardsHtml(g);
      else if(display === 'swatch')  html += renderPillsHtml(g);
      else if(display === 'switch')  html += renderSwitchesHtml(g);
      else if(g.type === 'multi')    html += renderSwitchesHtml(g);
      else if(display === 'select')  html += renderSelectHtml(g);
      else                           html += renderSwitchesHtml(g);

      html += '</div>';
      return html;
    }

    function renderRadioCardsHtml(g){
      var html = '<div class="vmfs-radio-group" role="radiogroup" aria-labelledby="vmfs-mopt-label-' + escAttr(g.id) + '">';
      g.options.forEach(function(opt, idx){
        var selected = state[g.id] === opt.value;
        var split    = splitLabel(opt.label || '', opt.subtitle);
        var titleText = split.label;
        var subtitleText = opt.subtitle || split.desc;
        var imgSrc = opt.image || '';
        var bullets = '';
        if(Array.isArray(opt.bullets) && opt.bullets.length){
          bullets = '<ul class="vmfs-radio-bullets">';
          opt.bullets.slice(0, 3).forEach(function(b){ bullets += '<li>' + escHtml(b) + '</li>'; });
          bullets += '</ul>';
        }
        var priceLabel = opt.priceLabel || (opt.priceCents > 0
          ? '+' + money(opt.priceCents, sym)
          : opt.priceCents < 0 ? money(opt.priceCents, sym) : 'Included');
        var priceCls = opt.priceCents > 0 ? 'vmfs-opt-price--add'
                      : opt.priceCents < 0 ? 'vmfs-opt-price--sub'
                      : 'vmfs-opt-price--inc';

        html += '<button type="button" '
              + 'role="radio" '
              + 'aria-checked="' + selected + '" '
              + 'tabindex="' + (selected || (idx===0 && !state[g.id]) ? '0' : '-1') + '" '
              + 'class="vmfs-radio-card' + (selected ? ' is-selected' : '') + '" '
              + 'data-option '
              + 'data-group-id="' + escAttr(g.id) + '" '
              + 'data-value="' + escAttr(opt.value) + '" '
              + 'data-multi="false">'
              // Image area with floating circle + optional badge
              + '<div class="vmfs-radio-card__image">'
              +   (opt.badge ? '<span class="vmfs-radio-badge">' + escHtml(opt.badge) + '</span>' : '')
              +   (imgSrc ? '<img src="' + escAttr(imgSrc) + '" alt="' + escAttr(titleText) + '">' : '')
              +   '<span class="vmfs-radio-circle' + (selected ? ' is-checked' : '') + '" aria-hidden="true">'
              +     (selected ? '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' : '')
              +   '</span>'
              + '</div>'
              // Body: title, subtitle, bullets, price (integrated)
              + '<div class="vmfs-radio-card__body">'
              +   '<div class="vmfs-radio-title">' + escHtml(titleText) + '</div>'
              +   (subtitleText ? '<div class="vmfs-radio-subtitle">' + escHtml(subtitleText) + '</div>' : '')
              +   bullets
              +   '<div class="vmfs-radio-card__price">'
              +     '<span class="vmfs-opt-price ' + priceCls + '">' + escHtml(priceLabel) + '</span>'
              +   '</div>'
              + '</div>'
              + '</button>';
      });
      html += '</div>';
      return html;
    }

    function renderPillsHtml(g){
      var html = '<div class="vmfs-pill-group" role="radiogroup" aria-labelledby="vmfs-mopt-label-' + escAttr(g.id) + '">';
      g.options.forEach(function(opt, idx){
        var selected = state[g.id] === opt.value;
        var sub = opt.priceCents !== 0
                  ? '<div class="vmfs-pill-sub">' + priceBadge(opt.priceCents, opt.priceLabel) + '</div>'
                  : '';
        html += '<button type="button" '
              + 'role="radio" '
              + 'aria-checked="' + selected + '" '
              + 'tabindex="' + (selected || (idx===0 && !state[g.id]) ? '0' : '-1') + '" '
              + 'class="vmfs-pill' + (selected ? ' is-selected' : '') + '" '
              + 'data-option '
              + 'data-group-id="' + escAttr(g.id) + '" '
              + 'data-value="' + escAttr(opt.value) + '" '
              + 'data-multi="false">'
              + '<span class="vmfs-pill-label">' + escHtml(opt.label || '') + '</span>'
              + sub
              + '</button>';
      });
      html += '</div>';
      return html;
    }

    function renderSwitchesHtml(g){
      var isMulti = g.type === 'multi';
      var role = isMulti ? 'group' : 'radiogroup';
      var html = '<div class="vmfs-toggle-group" role="' + role + '" aria-labelledby="vmfs-mopt-label-' + escAttr(g.id) + '">';
      g.options.forEach(function(opt){
        var selected;
        if(isMulti){
          selected = Array.isArray(state[g.id]) && state[g.id].indexOf(opt.value) >= 0;
        } else {
          selected = state[g.id] === opt.value;
        }
        var ariaRole = isMulti ? 'checkbox' : 'radio';
        var img = opt.image ? '<img class="vmfs-toggle-img" src="' + escAttr(opt.image) + '" alt="">' : '';
        // Smart label split: extract parenthetical into desc if no explicit desc
        var split = splitLabel(opt.label || '', opt.desc);
        var displayLabel = split.label;
        var descText = split.desc;
        var desc = descText ? '<div class="vmfs-toggle-desc">' + escHtml(descText) + '</div>' : '';
        html += '<button type="button" '
              + 'role="' + ariaRole + '" aria-checked="' + selected + '" '
              + 'class="vmfs-toggle-row' + (selected ? ' is-selected' : '') + '" '
              + 'data-option '
              + 'data-group-id="' + escAttr(g.id) + '" '
              + 'data-value="' + escAttr(opt.value) + '" '
              + 'data-multi="' + (isMulti ? 'true' : 'false') + '">'
              + '<div class="vmfs-toggle-info">'
              + img
              + '<div class="vmfs-toggle-text">'
              + '<div class="vmfs-toggle-name">' + escHtml(displayLabel) + '</div>'
              + desc
              + '</div>'
              + '</div>'
              + '<div class="vmfs-toggle-right">'
              + '<div class="vmfs-toggle-price">' + priceBadge(opt.priceCents, opt.priceLabel) + '</div>'
              + '<span class="vmfs-ios-toggle' + (selected ? ' is-on' : '') + '" aria-hidden="true"><span class="vmfs-ios-knob"></span></span>'
              + '</div>'
              + '</button>';
      });
      html += '</div>';
      return html;
    }

    function renderSelectHtml(g){
      var html = '<div class="vmfs-select-wrap">'
               + '<select class="vmfs-select" data-group-select="' + escAttr(g.id) + '" aria-labelledby="vmfs-mopt-label-' + escAttr(g.id) + '">';
      g.options.forEach(function(opt){
        var sel = state[g.id] === opt.value ? ' selected' : '';
        var priceLbl = opt.priceCents > 0 ? ' (+' + money(opt.priceCents, sym) + ')'
                     : opt.priceCents < 0 ? ' (' + money(opt.priceCents, sym) + ')'
                     : '';
        html += '<option value="' + escAttr(opt.value) + '"' + sel + '>'
              + escHtml(opt.label || '') + priceLbl
              + '</option>';
      });
      html += '</select>'
            + '<svg class="vmfs-select-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>'
            + '</div>';
      return html;
    }

    function priceBadge(cents, label){
      var c = Number(cents || 0);
      if(label){
        if(c > 0) return '<span class="vmfs-opt-price vmfs-opt-price--add">' + escHtml(label) + '</span>';
        if(c < 0) return '<span class="vmfs-opt-price vmfs-opt-price--sub">' + escHtml(label) + '</span>';
        return '<span class="vmfs-opt-price vmfs-opt-price--inc">' + escHtml(label) + '</span>';
      }
      if(c > 0) return '<span class="vmfs-opt-price vmfs-opt-price--add">+' + money(c, sym) + '</span>';
      if(c < 0) return '<span class="vmfs-opt-price vmfs-opt-price--sub">' + money(c, sym) + '</span>';
      return '<span class="vmfs-opt-price vmfs-opt-price--inc">Included</span>';
    }

    /* ═════════════════════════════════════════════════════════════════════
       BODY EVENTS
       ═══════════════════════════════════════════════════════════════════ */
    var _bodyBound = false;
    function bindBodyEvents(){
      if(_bodyBound) return;
      _bodyBound = true;

      els.cfgBody.addEventListener('click', function(e){
        // Help toggle
        var helpBtn = e.target.closest && e.target.closest('[data-help-toggle]');
        if(helpBtn){
          e.preventDefault();
          var groupId = helpBtn.dataset.helpToggle;
          openHelpId = (openHelpId === groupId) ? null : groupId;
          // Toggle just the affected items, no full re-render needed
          var helpRegion = els.cfgBody.querySelector('#vmfs-help-' + groupId);
          var isOpen = openHelpId === groupId;
          if(helpRegion){
            if(isOpen) helpRegion.removeAttribute('hidden');
            else helpRegion.setAttribute('hidden', '');
          }
          helpBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          helpBtn.setAttribute('aria-label', (isOpen ? 'Hide' : 'Show') + ' help');
          return;
        }
        // Option select
        var opt = e.target.closest && e.target.closest('[data-option]');
        if(opt){
          var groupId2 = opt.dataset.groupId;
          var value    = opt.dataset.value;
          var isMulti  = opt.dataset.multi === 'true';
          if(isMulti){
            if(!Array.isArray(state[groupId2])) state[groupId2] = [];
            var i = state[groupId2].indexOf(value);
            if(i >= 0) state[groupId2].splice(i, 1);
            else       state[groupId2].push(value);
          } else {
            state[groupId2] = value;
          }
          renderAll();
        }
      });

      els.cfgBody.addEventListener('change', function(e){
        var sel = e.target.closest && e.target.closest('select[data-group-select]');
        if(sel){
          state[sel.dataset.groupSelect] = sel.value;
          renderAll();
        }
      });

      els.cfgBody.addEventListener('keydown', function(e){
        var opt = e.target.closest && e.target.closest('[data-option]');
        if(!opt) return;
        if(e.key === ' ' || e.key === 'Enter'){
          e.preventDefault();
          opt.click();
        }
      });
    }

    /* ═════════════════════════════════════════════════════════════════════
       PRICING & LEAD TIME
       ═══════════════════════════════════════════════════════════════════ */
    function calcOptionsCents(){
      var total = 0;
      config.groups.forEach(function(g){
        if(!meetsRules(state, g.rules)) return;
        if(g.type === 'multi'){
          var arr = Array.isArray(state[g.id]) ? state[g.id] : [];
          arr.forEach(function(v){
            var o = (g.options || []).filter(function(x){return x.value===v;})[0];
            if(o) total += Number(o.priceCents || 0);
          });
        } else {
          var sel = state[g.id];
          var o2 = (g.options || []).filter(function(x){return x.value===sel;})[0];
          if(o2) total += Number(o2.priceCents || 0);
        }
      });
      return total;
    }
    function calcLeadTier(){
      var tier = 0;
      config.groups.forEach(function(g){
        if(!meetsRules(state, g.rules)) return;
        if(g.type === 'multi'){
          var arr = Array.isArray(state[g.id]) ? state[g.id] : [];
          arr.forEach(function(v){
            var o = (g.options || []).filter(function(x){return x.value===v;})[0];
            if(o && Number(o.leadTime || 0) > tier) tier = Number(o.leadTime);
          });
        } else {
          var sel = state[g.id];
          var o2 = (g.options || []).filter(function(x){return x.value===sel;})[0];
          if(o2 && Number(o2.leadTime || 0) > tier) tier = Number(o2.leadTime);
        }
      });
      return tier;
    }
    function buildSummaryItems(){
      var items = [];
      config.groups.forEach(function(g){
        if(!meetsRules(state, g.rules)) return;
        if(g.type === 'multi'){
          var arr = Array.isArray(state[g.id]) ? state[g.id] : [];
          arr.forEach(function(v){
            var o = (g.options || []).filter(function(x){return x.value===v;})[0];
            if(o) items.push({ group: g.label, optLabel: (o.label||'').replace(/\s*\(.*?\)\s*/g,'').trim(), priceCents: Number(o.priceCents||0) });
          });
        } else {
          var sel = state[g.id];
          var o2 = (g.options || []).filter(function(x){return x.value===sel;})[0];
          if(o2) items.push({ group: g.label, optLabel: (o2.label||'').replace(/\s*\(.*?\)\s*/g,'').trim(), priceCents: Number(o2.priceCents||0) });
        }
      });
      return items;
    }
    function renderPricing(){
      var optsCents = calcOptionsCents();
      var totalCents= baseCents + optsCents;

      if(els.basePriceEl) els.basePriceEl.textContent = money(baseCents, sym);
      if(els.optsPriceEl){
        var prefix = optsCents > 0 ? '+' : '';
        els.optsPriceEl.textContent = prefix + money(optsCents, sym);
      }
      if(els.totalEl)    els.totalEl.textContent    = money(totalCents, sym);

      var tier = calcLeadTier();
      var key  = tier === 0 ? 'green' : tier === 1 ? 'yellow' : 'orange';
      var lt   = leadTimes[key] || {label: 'Standard', days: '7-21 days', color: '#22c55e'};
      if(els.leadDot)   els.leadDot.style.background = lt.color;
      if(els.leadLabel) els.leadLabel.textContent = lt.label;
      if(els.leadDays)  els.leadDays.textContent  = lt.days;

      if(els.props){
        var html = '';
        config.groups.forEach(function(g){
          if(!meetsRules(state, g.rules)) return;
          var val;
          if(g.type === 'multi'){
            var arr = Array.isArray(state[g.id]) ? state[g.id] : [];
            val = arr.map(function(v){
              var o = (g.options || []).filter(function(x){return x.value===v;})[0];
              return o ? (o.label||'').replace(/\s*\(.*?\)\s*/g,'').trim() : '';
            }).filter(Boolean).join(', ');
          } else {
            var sel = state[g.id];
            var o2 = (g.options || []).filter(function(x){return x.value===sel;})[0];
            val = o2 ? (o2.label||'').replace(/\s*\(.*?\)\s*/g,'').trim() : '';
          }
          if(val){
            html += '<input type="hidden" name="properties[' + escAttr(g.label || g.id) + ']" value="' + escAttr(val) + '">';
          }
        });
        els.props.innerHTML = html;
      }

      renderSummaryPanel(totalCents);
      updateOrderBtnState();
    }
    function updateOrderBtnState(){
      if(!els.orderBtn) return;
      var ack = els.leadCheckbox ? els.leadCheckbox.checked : true;
      els.orderBtn.disabled = !ack;
    }
    function renderSummaryPanel(totalCents){
      if(!els.summaryBody) return;
      var items = buildSummaryItems();
      var html = '';
      html += '<div class="vmfs-sb-breakdown">';
      html += '<div class="vmfs-sb-row"><span class="vmfs-sb-row__label">Base price</span><span class="vmfs-sb-row__val">' + money(baseCents, sym) + '</span></div>';
      var paidItems = items.filter(function(it){ return it.priceCents !== 0; });
      if(paidItems.length){
        paidItems.forEach(function(it){
          var cls = it.priceCents > 0 ? 'vmfs-sb-add' : 'vmfs-sb-sub';
          var prefix = it.priceCents > 0 ? '+' : '';
          html += '<div class="vmfs-sb-row vmfs-sb-row--opt">'
                + '<span class="vmfs-sb-row__label">'
                + '<span class="vmfs-sb-row__group">' + escHtml(it.group) + '</span>'
                + '<span class="vmfs-sb-row__opt-val">' + escHtml(it.optLabel) + '</span>'
                + '</span>'
                + '<span class="vmfs-sb-row__val ' + cls + '">' + prefix + money(it.priceCents, sym) + '</span>'
                + '</div>';
        });
      }
      html += '<div class="vmfs-sb-divider"></div>';
      html += '<div class="vmfs-sb-row vmfs-sb-row--total"><span>Total</span><span class="vmfs-sb-total">' + money(totalCents, sym) + '</span></div>';
      html += '</div>';

      var included = items.filter(function(it){ return it.priceCents === 0; });
      if(included.length){
        html += '<div class="vmfs-sb-included">';
        html += '<div class="vmfs-sb-included__title">Included</div>';
        html += '<div class="vmfs-sb-included__list">';
        included.forEach(function(it){
          html += '<div class="vmfs-sb-included__item">'
                + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
                + '<span><strong>' + escHtml(it.group) + ':</strong> ' + escHtml(it.optLabel) + '</span>'
                + '</div>';
        });
        html += '</div></div>';
      }
      els.summaryBody.innerHTML = html || '<p class="vmfs-sb-empty">Select options to see your configuration breakdown.</p>';
    }

    /* ═════════════════════════════════════════════════════════════════════
       MEDIA / IMAGE OVERRIDE
       ═══════════════════════════════════════════════════════════════════ */
    var lastResolvedImage = null;
    var userDismissedOverride = false;
    function renderMedia(){
      if(!els.galleryOverride || !els.overrideImg) return;
      var rules = imageRules || [];
      var resolved = null;
      for(var i=0; i<rules.length; i++){
        if(meetsRules(state, rules[i])){ resolved = rules[i].image; break; }
      }
      if(!resolved){
        config.groups.forEach(function(g){
          if(g.display !== 'radio') return;
          if(!meetsRules(state, g.rules)) return;
          var sel = state[g.id];
          var opt = (g.options || []).filter(function(x){return x.value===sel;})[0];
          if(opt && opt.image && !resolved) resolved = opt.image;
        });
      }
      if(resolved !== lastResolvedImage){
        userDismissedOverride = false;
        lastResolvedImage = resolved;
      }
      if(resolved && !userDismissedOverride){ showOverride(resolved); }
      else { hideOverride(); }
    }
    function showOverride(src){
      if(!els.galleryOverride || !els.overrideImg) return;
      els.overrideImg.src = src;
      els.overrideImg.alt = 'Selected configuration';
      els.galleryOverride.classList.add('is-active');
      els.galleryOverride.setAttribute('aria-hidden','false');
      if(els.galleryMain) els.galleryMain.classList.add('is-locked');
      [els.galleryPrev, els.galleryNext].forEach(function(el){ if(el) el.classList.add('is-disabled'); });
      Array.prototype.forEach.call(els.thumbs, function(t){ t.classList.add('is-disabled'); });
    }
    function hideOverride(){
      if(!els.galleryOverride) return;
      els.galleryOverride.classList.remove('is-active');
      els.galleryOverride.setAttribute('aria-hidden','true');
      if(els.galleryMain) els.galleryMain.classList.remove('is-locked');
      [els.galleryPrev, els.galleryNext].forEach(function(el){ if(el) el.classList.remove('is-disabled'); });
      Array.prototype.forEach.call(els.thumbs, function(t){ t.classList.remove('is-disabled'); });
    }

    /* ═════════════════════════════════════════════════════════════════════
       SPEC STACK
       ═══════════════════════════════════════════════════════════════════ */
    function renderSpecStack(){
      if(!els.specStack) return;
      var specs = null;
      config.groups.forEach(function(g){
        if(g.display !== 'radio') return;
        if(!meetsRules(state, g.rules)) return;
        var sel = state[g.id];
        var opt = (g.options || []).filter(function(x){return x.value===sel;})[0];
        if(opt && Array.isArray(opt.specs) && opt.specs.length && !specs) specs = opt.specs;
      });
      if(!specs || !specs.length){
        els.specStack.classList.remove('is-active');
        els.specStack.innerHTML = '';
        return;
      }
      var html = '';
      specs.slice(0, 6).forEach(function(s, i){
        html += '<div class="vmfs-spec-card" style="animation-delay:' + (i * 60) + 'ms">'
              + '<div class="vmfs-spec-card__icon">' + getSpecIcon(s.icon) + '</div>'
              + '<div class="vmfs-spec-card__body">'
              + '<div class="vmfs-spec-card__value">' + escHtml(s.value || '') + '</div>'
              + '<div class="vmfs-spec-card__label">' + escHtml(s.label || '') + '</div>'
              + '</div>'
              + '</div>';
      });
      els.specStack.innerHTML = html;
      els.specStack.classList.add('is-active');
    }

    /* ═════════════════════════════════════════════════════════════════════
       GALLERY (slider, swipe, thumbs)
       ═══════════════════════════════════════════════════════════════════ */
    var currentSlide = 0;
    var totalSlides = els.galleryTrack ? els.galleryTrack.children.length : 0;
    function goToSlide(idx){
      if(!els.galleryTrack || !totalSlides) return;
      if(els.galleryMain && els.galleryMain.classList.contains('is-locked')) return;
      currentSlide = Math.max(0, Math.min(idx, totalSlides - 1));
      els.galleryTrack.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      if(els.counterCurrent) els.counterCurrent.textContent = (currentSlide + 1).toString();
      Array.prototype.forEach.call(els.thumbs, function(t){
        t.classList.toggle('is-active', Number(t.dataset.thumbIndex) === currentSlide);
      });
    }
    if(els.galleryPrev) els.galleryPrev.addEventListener('click', function(){ goToSlide(currentSlide - 1); });
    if(els.galleryNext) els.galleryNext.addEventListener('click', function(){ goToSlide(currentSlide + 1); });
    Array.prototype.forEach.call(els.thumbs, function(t){
      t.addEventListener('click', function(){ goToSlide(Number(t.dataset.thumbIndex)); });
    });
    if(els.galleryMain){
      var startX = 0, startY = 0, isSwipe = false;
      els.galleryMain.addEventListener('touchstart', function(e){
        if(els.galleryMain.classList.contains('is-locked')) return;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY; isSwipe = true;
      }, {passive: true});
      els.galleryMain.addEventListener('touchend', function(e){
        if(!isSwipe || els.galleryMain.classList.contains('is-locked')) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if(Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50){
          if(dx < 0) goToSlide(currentSlide + 1); else goToSlide(currentSlide - 1);
        }
        isSwipe = false;
      });
    }
    document.addEventListener('keydown', function(e){
      if(e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT' || e.target.tagName === 'BUTTON')) return;
      if(e.key === 'ArrowLeft')  goToSlide(currentSlide - 1);
      if(e.key === 'ArrowRight') goToSlide(currentSlide + 1);
    });
    if(els.galleryOverride){
      els.galleryOverride.addEventListener('click', function(){
        if(els.galleryOverride.classList.contains('is-active')){
          userDismissedOverride = true;
          hideOverride();
        }
      });
    }

    /* ═════════════════════════════════════════════════════════════════════
       DESCRIPTION TABS
       ═══════════════════════════════════════════════════════════════════ */
    Array.prototype.forEach.call(els.descTabs, function(tab){
      tab.addEventListener('click', function(){
        var key = tab.dataset.tab;
        Array.prototype.forEach.call(els.descTabs, function(t){
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        Array.prototype.forEach.call(els.descPanels, function(p){
          var on = p.dataset.panel === key;
          p.classList.toggle('is-active', on);
          if(on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
      });
    });

    /* ═════════════════════════════════════════════════════════════════════
       SUMMARY PANEL TOGGLE
       ═══════════════════════════════════════════════════════════════════ */
    if(els.summaryToggle && els.summaryPanel){
      els.summaryToggle.addEventListener('click', function(){
        var open = els.summaryPanel.classList.toggle('is-open');
        els.summaryToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(els.summaryChevron) els.summaryChevron.style.transform = open ? 'rotate(180deg)' : 'rotate(0deg)';
        if(els.toggleLabel)    els.toggleLabel.textContent = open ? 'Hide Order Summary' : 'View Order Summary';
      });
    }

    if(els.leadCheckbox){
      els.leadCheckbox.addEventListener('change', updateOrderBtnState);
    }

    /* ═════════════════════════════════════════════════════════════════════
       FORM SUBMIT (Cloudflare Worker)
       ═══════════════════════════════════════════════════════════════════ */
    if(els.form){
      els.form.addEventListener('submit', function(e){
        if(!WORKER_URL) return;
        e.preventDefault();
        if(els.orderBtn){
          els.orderBtn.disabled = true;
          els.orderBtn.innerHTML = '<svg class="vmfs-btn-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity=".25"/><path d="M22 12a10 10 0 0 0-10-10"/></svg><span>Processing...</span>';
        }

        var optsCents = calcOptionsCents();
        var totalCents= baseCents + optsCents;
        var properties= {};
        config.groups.forEach(function(g){
          if(!meetsRules(state, g.rules)) return;
          var val;
          if(g.type === 'multi'){
            var arr = Array.isArray(state[g.id]) ? state[g.id] : [];
            val = arr.map(function(v){
              var o = (g.options || []).filter(function(x){return x.value===v;})[0];
              return o ? (o.label||'').replace(/\s*\(.*?\)\s*/g,'').trim() : '';
            }).filter(Boolean).join(', ');
          } else {
            var sel = state[g.id];
            var o2 = (g.options || []).filter(function(x){return x.value===sel;})[0];
            val = o2 ? (o2.label||'').replace(/\s*\(.*?\)\s*/g,'').trim() : '';
          }
          if(val) properties[g.label || g.id] = val;
        });

        var variantId = (els.form.querySelector('[name="id"]') || {}).value || null;

        fetch(WORKER_URL, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            totalCents: totalCents,
            baseCents: baseCents,
            optionsCents: optsCents,
            properties: properties,
            variantId: variantId,
            currencySymbol: sym
          })
        })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if(data && data.checkoutUrl){
            window.location.href = data.checkoutUrl;
          } else {
            throw new Error(data && data.error ? data.error : 'No checkout URL returned');
          }
        })
        .catch(function(err){
          console.error('[VMFS] Checkout error:', err);
          alert('There was a problem creating your order. Please try again.');
          if(els.orderBtn){
            els.orderBtn.disabled = false;
            els.orderBtn.innerHTML = '<span>Add to Cart</span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          }
        });
      });
    }

    /* ═════════════════════════════════════════════════════════════════════
       MASTER RENDER
       ═══════════════════════════════════════════════════════════════════ */
    function renderAll(){
      renderTabs();
      renderBody();
      renderPricing();
      renderMedia();
      renderSpecStack();
    }

    /* ═════════════════════════════════════════════════════════════════════
       APPLY DEFAULTS + INITIAL RENDER
       ═══════════════════════════════════════════════════════════════════ */
    if(Array.isArray(config.defaults)){
      config.defaults.forEach(function(d){
        if(d && d.id) state[d.id] = (Array.isArray(d.value) ? d.value.slice() : d.value);
      });
    }
    renderAll();
  }

  /* ── Boot ─────────────────────────────────────────────────────────────── */
  function boot(){
    document.querySelectorAll('[data-vmfs-nectar]').forEach(init);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();